import { extractNumbers } from '@/utils/extract-numbers';

export const phoneMask = (number: string = '') => {
  let phoneNumber = extractNumbers(number);

  if (phoneNumber) {
    phoneNumber = phoneNumber.replace(/\D/g, '');
    phoneNumber = phoneNumber.substring(0, 11);
    phoneNumber = phoneNumber.replace(/^(\d{2})(\d)/g, '($1) $2');
    phoneNumber = phoneNumber.replace(/(\d)(\d{4})$/, '$1-$2');
    return phoneNumber;
  }
  return '';
};
